import { createLazyComponent } from "@shared/utils/lazyUtils";

// Auth Components - Split auth-related code into separate chunks
export const LazyLogin = createLazyComponent(
  () => import("@features/auth/components/Login"),
  { chunkName: "auth-login" },
);

export const LazySSOCallback = createLazyComponent(
  () => import("@components/SSOCallback"),
  { chunkName: "auth-sso" },
);

// Layout Components
export const LazyAppLayout = createLazyComponent(
  () => import("@components/AppLayout"),
  { chunkName: "app-layout" },
);

export const LazyProtectedRoute = createLazyComponent(
  () => import("@components/ProtectedRoute"),
  { chunkName: "protected-route" },
);

// Utility Components
// Note: NotFoundPage is not lazy-loaded as it's statically imported by
// LazyErrorBoundary and NetworkGuard for immediate error handling

export const LazyNetworkGuard = createLazyComponent(
  () => import("@components/NetworkGuard"),
  { chunkName: "network-guard" },
);

// Page Components - Each major page gets its own chunk
export const LazyHome = createLazyComponent(() => import("@/pages/Home"), {
  chunkName: "page-home",
});

export const LazyBuilder = createLazyComponent(
  () => import("@/pages/Builder"),
  { chunkName: "page-builder" },
);

export const LazySectionPreview = createLazyComponent(
  () => import("@/pages/SectionPreview"),
  { chunkName: "page-section-preview" },
);

// Feature Components - Lazy load feature-specific components
export const LazySurveyDeprecationNotice = createLazyComponent(
  () =>
    import("@features/home/components/SurveyDeprecationNotice").then(
      (module) => ({
        default: module.SurveyDeprecationNotice,
      }),
    ),
  { chunkName: "home-deprecation-notice" },
);

export const LazySurveyList = createLazyComponent(
  () =>
    import("@features/home/components/SurveyList").then((module) => ({
      default: module.SurveyList,
    })),
  { chunkName: "home-survey-list" },
);

export const LazyNewSurveyButton = createLazyComponent(
  () =>
    import("@features/home/components/NewSurveyButton").then((module) => ({
      default: module.NewSurveyButton,
    })),
  { chunkName: "home-new-survey-button" },
);

// Preload functions for critical routes
export const preloadAuthComponents = () => {
  import("@features/auth/components/Login");
  import("@components/SSOCallback");
};

export const preloadMainAppComponents = () => {
  import("@components/AppLayout");
  import("@components/ProtectedRoute");
  import("@/pages/Home");
};
